import type { ComponentPropsWithoutRef } from 'react'

const BASE = import.meta.env.BASE_URL.endsWith('/') ? import.meta.env.BASE_URL : `${import.meta.env.BASE_URL}/`
const MARK_SRC = `${BASE}brand/defendsphere-mark.png`

export type BrandLogoMarkProps = ComponentPropsWithoutRef<'img'> & {
  /** Extra class on the white rounded wrapper */
  wrapperClassName?: string
}

/**
 * DefendSphere diamond mark inside a white circular plate (mobile header + nav drawer).
 */
export function BrandLogoMark({ wrapperClassName = '', className: _className, alt = '', ...imgProps }: BrandLogoMarkProps) {
  return (
    <span className={['brand-logo-mark', wrapperClassName].filter(Boolean).join(' ')} aria-hidden={alt === ''}>
      <img src={MARK_SRC} alt={alt} width={32} height={32} decoding="async" draggable={false} {...imgProps} />
    </span>
  )
}
